export const MAX_NOTES_LENGTH = 10000;
export const IMAGE_REJECTION_COUNT_BEFORE_MANUAL_EDIT = 3;

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_SIZE_XL = 50;

export const SIDEBAR_WIDTH = 270;